import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiV1 } from "api-v2";
import { useCurrentCompanyId } from "hooks/auth";
import type { UserListItem } from "../../../types/userInvite";

const reactivateUser = async (userId: number): Promise<UserListItem> => {
  // Reactivate returns a UserResource, enveloped as { data: ... }. Unwrap so
  // callers get the updated user (its status may be "active" or "invited"
  // depending on whether the user had previously registered).
  const response = await apiV1.post<{ data: UserListItem }>(`users/${userId}/reactivate`);
  return response.data.data;
};

export const useReactivateUserMutation = () => {
  const queryClient = useQueryClient();
  const companyId = useCurrentCompanyId();

  return useMutation<UserListItem, Error, number>({
    mutationFn: reactivateUser,
    retry: false,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users", companyId] });
    },
  });
};
